import type { IIssueRepository, IssueUpdateInput } from '../repositories/IIssueRepository.js';
import type { IssueEntity } from '../entities/IssueEntity.js';

export interface UpdateIssueInput { id: string; data: IssueUpdateInput; }

interface Deps { issueRepository: IIssueRepository; }

export function createUpdateIssueUseCase({ issueRepository }: Deps) {
  return async function updateIssue({ id, data }: UpdateIssueInput): Promise<IssueEntity | null> {
    return issueRepository.update(id, data);
  };
}
